// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+sEAX","tabList":"styles_tabList__+Lx9X","tabPanel":"styles_tabPanel__ktW1v","controls":"styles_controls__a0uMh"};